import script from "./pageSearch.vue?vue&type=script&setup=true&lang=js"
export * from "./pageSearch.vue?vue&type=script&setup=true&lang=js"

import "./pageSearch.vue?vue&type=style&index=0&id=53e33e7d&lang=less&scoped=true"

import exportComponent from "D:\\workspace\\payment-system-merchant\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-53e33e7d"]])

export default __exports__